import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import HomePage from '@/pages/HomePage'
import productPage from '@/pages/Product'
import newsPage from '@/pages/News'
import videoPage from '@/pages/Video'
import aboutPage from '@/pages/About'
import joinPage from '@/pages/Join'

Vue.use(Router)

export default new Router({
  // mode: 'hash',
  routes: [
    /* {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }, */
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/product/:key/:anchor',
      name: 'productPage',
      component: productPage
    },
    {
      path: '/news',
      name: 'newsPage',
      component: newsPage
    },
    {
      path: '/video/:index',
      name: 'videoPage',
      component: videoPage
    },
    {
      path: '/aboutUs/:anchor',
      name: 'aboutPage',
      component: aboutPage
    },
    {
      path: '/joinUs',
      name: 'joinPage',
      component: joinPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js